module.exports = "img/flags/BT.e0697c7.png";